import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentReturn";
import GlobalLeaderboard from "@/pages/GlobalLeaderboard";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Claim from "@/pages/Claim";
import HowItWorks from "@/pages/HowItWorks";
import LeaguePredictor from "@/pages/LeaguePredictor";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("gaffer-ref", ref);
  }, []);
  return (
    <div className="App grain">
      <HelmetProvider>
        <I18nProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Auth mode="login" />} />
                <Route path="/register" element={<Auth mode="register" />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/claim/:code" element={<Claim />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/predictor/:slug" element={<LeaguePredictor />} />
                <Route path="/app" element={<Protected><Dashboard /></Protected>} />
                <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
                <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
                <Route path="/leaderboard" element={<Protected><GlobalLeaderboard /></Protected>} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" />
          </AuthProvider>
        </I18nProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
